<template>
  <div class="rows">
    <label class="input-label" :for="id">
      <span v-if="icon" class="icon">
        <base-icon :name="icon" />
      </span>
      <span v-if="label" class="text">{{ label }}</span>
    </label>
    <input :id="id" class="input-inner" v-bind="$attrs" :value="value" v-on="listeners">
    <div class="input-right">
      <slot name="input-right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseHintInput',
  props: {
    value: [String, Number],
    id: String,
    label: String,
    icon: String,
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit('input', event.target.value);
        },
      };
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  /* Chrome */
  color: #999;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #999;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #999;
  opacity: 1;
}
:-moz-placeholder {
  /* Firefox 4 - 18 */
  color: #999;
  opacity: 1;
}
.rows {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 400;
  background-color: #f1f2f6;
  border-radius: 4px;
  padding: 20px;
  height: 90px;
  margin-bottom: 30px;
  .input-inner {
    width: 100%;
    flex: 1;
    border: 0;
    color: #333;
    padding: 0;
    background: transparent;
  }
  .input-label {
    display: flex;
    color: #aeaeae;
    margin-right: 20px;
    .icon {
      display: block;
      width: 36px;
      height: 36px;
    }
    .text {
      color: #333;
      margin-left: 10px;
    }
  }
}
</style>
